import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { HOSPITAL, NAV } from "../data/site";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A1515] text-white/80 mt-20"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <div className="bg-white rounded-xl p-1.5">
              <img
                src={HOSPITAL.logo}
                alt="Family HealthCare"
                className="h-12 w-12 object-contain"
              />
            </div>
            <div>
              <div className="font-serif-display text-2xl text-white">
                Family <span className="text-[#E8B7BB]">HealthCare</span>
              </div>
              <div className="text-[11px] uppercase tracking-[0.18em] text-[#E8B7BB] font-semibold">
                Hospital
              </div>
            </div>
          </div>
          <p className="mt-6 text-sm leading-relaxed max-w-sm text-white/70">
            A trusted multi-speciality hospital serving the families of Garhi
            Harsaru and surrounding areas of Gurugram with affordable, quality
            care — every day, all day.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-[#E8B7BB] mb-4">
            Explore
          </h4>
          <ul className="space-y-2.5 text-sm">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link
                  to={n.to}
                  data-testid={`footer-link-${n.label.toLowerCase()}`}
                  className="hover:text-white transition"
                >
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-5">
          <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-[#E8B7BB] mb-4">
            Reach us
          </h4>
          <ul className="space-y-3.5 text-sm">
            <li className="flex gap-3">
              <MapPin size={18} className="mt-0.5 text-[#E8B7BB]" />
              <span className="leading-relaxed">{HOSPITAL.address}</span>
            </li>
            <li className="flex gap-3 items-center">
              <Phone size={18} className="text-[#E8B7BB]" />
              <a
                href={`tel:${HOSPITAL.phoneDial}`}
                data-testid="footer-phone"
                className="hover:text-white"
              >
                {HOSPITAL.phone}
              </a>
            </li>
            <li className="flex gap-3 items-center">
              <Mail size={18} className="text-[#E8B7BB]" />
              <a
                href={`mailto:${HOSPITAL.email}`}
                data-testid="footer-email"
                className="hover:text-white"
              >
                {HOSPITAL.email}
              </a>
            </li>
            <li className="flex gap-3 items-center">
              <Clock size={18} className="text-[#E8B7BB]" />
              <span>{HOSPITAL.hoursLabel}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between text-xs text-white/55 gap-2">
          <span>© {year} Family HealthCare Hospital. All rights reserved.</span>
          <span>Made with care for the people of Gurugram.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
